export default {
  '/approval/getNotice': {
    method: 'get',
    reply: 200,
    data: { status: '0', msg: 'success', data: [] },
  },
  '/auth/getUserInfo': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: {
        name: 'BBAProduction TEST500927,BBA',
        email: 'test500927@bmw-brilliance.cn',
        account: 'U0500927',
        department: 'BBA',
        vpRoleStr: 'PI,Data Breach Role',
        roles: [1, 2, 4, 15],
        roleNames: ['DMGF', 'ADMIN', 'DTO', 'Prime KR Owner'],
        privilegeBtns: ['kpiManagement:create', 'kpiManagement:upload', 'kpiManagement:download'],
        rbacPriList: [
          {
            id: 1,
            pid: 0,
            label: 'Home',
            key: 'Home',
            name: '/main',
            icon: 'home',
            type: 'router',
            seq: 1,
            children: [],
          },
          {
            id: 4,
            pid: 0,
            label: 'Data Resource',
            key: 'Metadata',
            name: '/',
            icon: 'metadataManage',
            type: '',
            seq: 2,
            children: [
              {
                id: 6,
                pid: 4,
                label: 'Data Wheel',
                key: '/datawheel',
                name: '/datawheel',
                icon: 'DataWheelIcon',
                type: 'router',
                seq: 1,
                children: [],
              },
              {
                id: 14,
                pid: 4,
                label: 'Data Asset Overview',
                key: '/dataasset',
                name: '/dataasset',
                icon: 'DatasetIcon',
                type: 'router',
                seq: 2,
                children: [
                  {
                    id: 15,
                    pid: 14,
                    label: 'Future Data Asset',
                    key: '/futuredataset',
                    name: '/futuredataset',
                    icon: '',
                    type: 'router',
                    seq: 1,
                    children: [],
                  },
                  {
                    id: 17,
                    pid: 14,
                    label: 'Metadata Score Overview',
                    key: '/metadataoverview',
                    name: '/metadataoverview',
                    icon: '',
                    type: 'router',
                    seq: 3,
                    children: [],
                  },
                ],
              },
              {
                id: 16,
                pid: 4,
                label: 'Source Systems',
                key: '/sourceSystem',
                name: '/sourceSystem',
                icon: 'SourceSystemsIcon',
                type: 'router',
                seq: 4,
                children: [],
              },
              {
                id: 38,
                pid: 4,
                label: 'Data Map',
                key: '/chartsMap',
                name: '/chartsMap',
                icon: 'dataMapSvg',
                type: 'router',
                seq: 6,
                children: [],
              },
              {
                id: 71,
                pid: 4,
                label: 'Metadata Browser',
                key: '/metadataBrowser',
                name: '/metadataBrowser',
                icon: 'metadataBrowerSvg',
                type: '',
                seq: 7,
                children: [
                  {
                    id: 72,
                    pid: 71,
                    label: 'Database',
                    key: '/metaDataDataBase',
                    name: '/metaDataDataBase',
                    icon: '',
                    type: 'router',
                    seq: 2,
                    children: [],
                  },
                  {
                    id: 73,
                    pid: 71,
                    label: 'Table',
                    key: '/metaDataTable',
                    name: '/metaDataTable',
                    icon: '',
                    type: 'router',
                    seq: 3,
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            id: 39,
            pid: 0,
            label: 'Data Standards',
            key: 'dataStandards',
            name: 'dataStandards',
            icon: 'dataStandards',
            type: 'router',
            seq: 3,
            children: [
              {
                id: 61,
                pid: 39,
                label: 'Foundational Data Standards Lib',
                key: '/foundational',
                name: '/foundational',
                icon: 'foundationalSvg',
                type: 'router',
                seq: 1,
                children: [],
              },
              {
                id: 40,
                pid: 39,
                label: 'KPI Lib',
                key: '/kpiInformation',
                name: '/kpiInformation',
                icon: 'KPIInformation',
                type: 'router',
                seq: 2,
                children: [],
              },
              {
                id: 46,
                pid: 39,
                label: 'Reference Data Lib',
                key: '/referenceDataLib',
                name: '/referenceDataLib',
                icon: 'dimensionSvg',
                type: 'router',
                seq: 4,
                children: [],
              },
              {
                id: 60,
                pid: 39,
                label: 'Business Glossary',
                key: '/businessGlossary',
                name: '/businessGlossary',
                icon: 'businessTerminSvg',
                type: 'router',
                seq: 5,
                children: [],
              },
            ],
          },
          {
            id: 5,
            pid: 0,
            label: 'Data Quality',
            key: 'dataQuality',
            name: '/dataquality',
            icon: 'dataquality',
            type: '',
            seq: 4,
            children: [
              {
                id: 27,
                pid: 5,
                label: 'Data Quality Overview',
                key: '/dqReport',
                name: '/dqReport',
                icon: 'DataQualityOverviewIcon',
                type: '',
                seq: 1,
                children: [
                  {
                    id: 65,
                    pid: 27,
                    label: 'DQ Report',
                    key: '/dqReport',
                    name: '/dqReport',
                    icon: '',
                    type: 'router',
                    seq: 1,
                    children: [],
                  },
                  {
                    id: 32,
                    pid: 27,
                    label: 'Checkpoints Overview',
                    key: '/checkpointOverview',
                    name: '/checkpointOverview',
                    icon: '',
                    type: 'router',
                    seq: 2,
                    children: [],
                  },
                ],
              },
              {
                id: 29,
                pid: 5,
                label: 'Rule Template',
                key: '/ruleTemplate',
                name: '/ruleTemplate',
                icon: 'RuleTemplatesIcon',
                type: 'router',
                seq: 2,
                children: [],
              },
              {
                id: 28,
                pid: 5,
                label: 'Rules',
                key: '/ruleOverview',
                name: '/ruleOverview',
                icon: 'RulesIcon',
                type: 'router',
                seq: 3,
                children: [],
              },
              {
                id: 30,
                pid: 5,
                label: 'DQ Jobs',
                key: '/jobOverview',
                name: '/jobOverview',
                icon: 'DQJobsIcon',
                type: 'router',
                seq: 4,
                children: [],
              },
              {
                id: 31,
                pid: 5,
                label: 'DQ Issues',
                key: '/dataQualityIssue',
                name: '/dataQualityIssue',
                icon: 'DQIssuesIcon',
                type: 'router',
                seq: 5,
                children: [],
              },
            ],
          },
          {
            id: 69,
            pid: 0,
            label: 'Master Data',
            key: 'MasterData',
            name: '/',
            icon: 'MasterData',
            type: '',
            seq: 5,
            children: [
              {
                id: 70,
                pid: 69,
                label: 'Master Data Catalog',
                key: '/masterDataCatalog',
                name: '/masterDataCatalog',
                icon: 'masterData_svg',
                type: 'router',
                seq: 1,
                children: [],
              },
              {
                id: 75,
                pid: 69,
                label: 'Matser Data Logical Entity Overview',
                key: '/masterDataEntityOverview',
                name: '/masterDataEntityOverview',
                icon: 'masterEntityOverviewSvg',
                type: 'router',
                seq: 2,
                children: [],
              },
            ],
          },
          {
            id: 2,
            pid: 0,
            label: 'Data Governance',
            key: 'Vprivacy',
            name: '/vprivacy',
            icon: 'datagover',
            type: '',
            seq: 6,
            children: [],
          },
          {
            id: 19,
            pid: 0,
            label: 'My Workspace',
            key: 'MyWorkspace',
            name: 'MyWorkspace',
            icon: 'MyWorkspace',
            type: 'router',
            seq: 7,
            children: [
              {
                id: 24,
                pid: 19,
                label: 'Request Management',
                key: '/myStandRequest',
                name: '/myStandRequest',
                icon: 'RequestIcon',
                type: 'router',
                seq: 1,
                children: [],
              },
              {
                id: 20,
                pid: 19,
                label: 'Data Wheel Management',
                key: '/datawheelManage',
                name: '/datawheelManage',
                icon: 'DataWheelIcon',
                type: 'router',
                seq: 2,
                children: [],
              },
              {
                id: 21,
                pid: 19,
                label: 'Data Asset Overview Management',
                key: '/dataassetManage',
                name: '/dataassetManage',
                icon: 'DatasetIcon',
                type: 'router',
                seq: 3,
                children: [
                  {
                    id: 26,
                    pid: 21,
                    label: 'Future Data Asset Management',
                    key: '/futuredatasetManage',
                    name: '/futuredatasetManage',
                    icon: '',
                    type: 'router',
                    seq: 1,
                    children: [],
                  },
                ],
              },
              {
                id: 23,
                pid: 19,
                label: 'Data Standards Management',
                key: '/dataStandards',
                name: '/dataStandards',
                icon: 'DataStandardsIcon',
                type: '',
                seq: 4,
                children: [
                  {
                    id: 64,
                    pid: 23,
                    label: 'Foundational Data Standards Management',
                    key: '/foundationalManage',
                    name: '/foundationalManage',
                    icon: '',
                    type: 'router',
                    seq: 1,
                    children: [],
                  },
                  {
                    id: 42,
                    pid: 23,
                    label: 'KPI Standard Definition',
                    key: '/basicKPIManagement',
                    name: '/basicKPIManagement',
                    icon: '',
                    type: 'router',
                    seq: 2,
                    children: [],
                  },
                  {
                    id: 43,
                    pid: 23,
                    label: 'Reference Data Management',
                    key: '/referenceDataManagement',
                    name: '/referenceDataManagement',
                    icon: '',
                    type: 'router',
                    seq: 3,
                    children: [],
                  },
                  {
                    id: 63,
                    pid: 23,
                    label: 'Business Glossary Management',
                    key: '/businessGlossaryManagement',
                    name: '/businessGlossaryManagement',
                    icon: '',
                    type: 'router',
                    seq: 4,
                    children: [],
                  },
                ],
              },
              {
                id: 67,
                pid: 19,
                label: 'Master Data Management',
                key: '/masterDataManage',
                name: '/masterDataManage',
                icon: 'masterData_svg',
                type: '',
                seq: 5,
                children: [
                  {
                    id: 68,
                    pid: 67,
                    label: 'Master Data Catalog',
                    key: '/masterDataCatalogManage',
                    name: '/masterDataCatalogManage',
                    icon: '',
                    type: 'router',
                    seq: 1,
                    children: [],
                  },
                  {
                    id: 74,
                    pid: 67,
                    label: 'Service Management',
                    key: '/serviceManagement',
                    name: '/serviceManagement',
                    icon: '',
                    type: 'router',
                    seq: 2,
                    children: [],
                  },
                ],
              },
              {
                id: 34,
                pid: 19,
                label: 'Data Quality Management',
                key: null,
                name: null,
                icon: 'DataQualityOverviewIcon',
                type: '',
                seq: 6,
                children: [
                  {
                    id: 36,
                    pid: 34,
                    label: 'DQ Rule Template',
                    key: '/dqruleTemplate',
                    name: '/dqruleTemplate',
                    icon: '',
                    type: 'router',
                    seq: 1,
                    children: [],
                  },
                  {
                    id: 35,
                    pid: 34,
                    label: 'DQ Rule',
                    key: '/dqrule',
                    name: '/dqrule',
                    icon: '',
                    type: 'router',
                    seq: 2,
                    children: [],
                  },
                  {
                    id: 37,
                    pid: 34,
                    label: 'DQ Jobs',
                    key: '/dqjob',
                    name: '/dqjob',
                    icon: '',
                    type: 'router',
                    seq: 3,
                    children: [],
                  },
                ],
              },
              {
                id: 22,
                pid: 19,
                label: 'Meta Model Management',
                key: '/metaModelManage',
                name: '/metaModelManage',
                icon: 'MetaModelIcon',
                type: 'router',
                seq: 7,
                children: [],
              },
            ],
          },
          {
            id: 53,
            pid: 0,
            label: 'Operations',
            key: 'Operations',
            name: '/operations',
            icon: 'Operations',
            type: 'router',
            seq: 8,
            children: [
              {
                id: 58,
                pid: 53,
                label: 'Daily Dashboard',
                key: '/dailyDashboard',
                name: '/dailyDashboard',
                icon: 'daily_Dashboard_svg',
                type: 'router',
                seq: 1,
                children: [],
              },
              {
                id: 66,
                pid: 53,
                label: 'Data Asset Permission',
                key: '/dataAssetPermission',
                name: '/dataAssetPermission',
                icon: 'DataWheelIcon',
                type: 'router',
                seq: 2,
                children: [],
              },
              {
                id: 57,
                pid: 53,
                label: 'Feedback List',
                key: '/feedbackList',
                name: '/feedbackList',
                icon: 'feedback_svg',
                type: 'router',
                seq: 3,
                children: [],
              },
              {
                id: 54,
                pid: 53,
                label: 'User',
                key: '/user',
                name: '/user',
                icon: 'user_svg',
                type: 'router',
                seq: 4,
                children: [],
              },
              {
                id: 55,
                pid: 53,
                label: 'Role',
                key: '/role',
                name: '/role',
                icon: 'role_svg',
                type: 'router',
                seq: 5,
                children: [],
              },
              {
                id: 56,
                pid: 53,
                label: 'Privileges',
                key: '/privileges',
                name: '/privileges',
                icon: 'privileges_svg',
                type: 'router',
                seq: 6,
                children: [],
              },
            ],
          },
        ],
      },
    },
  },

  '/cdh/data/feedback/menuOptions': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: [
        { id: 1, pid: null, label: 'Home', children: null },
        {
          id: 4,
          pid: null,
          label: 'Data Resource',
          children: [
            { id: 6, pid: null, label: 'Data Wheel', children: null },
            {
              id: 14,
              pid: null,
              label: 'Data Asset Overview',
              children: [
                { id: 15, pid: null, label: 'Future Data Asset', children: null },
                { id: 17, pid: null, label: 'Metadata Score Overview', children: null },
              ],
            },
            { id: 16, pid: null, label: 'Source Systems', children: null },
            { id: 38, pid: null, label: 'Data Map', children: null },
            {
              id: 71,
              pid: null,
              label: 'Metadata Browser',
              children: [
                { id: 72, pid: null, label: 'Database', children: null },
                { id: 73, pid: null, label: 'Table', children: null },
              ],
            },
          ],
        },
        {
          id: 39,
          pid: null,
          label: 'Data Standards',
          children: [
            { id: 61, pid: null, label: 'Foundational Data Standards Lib', children: null },
            { id: 40, pid: null, label: 'KPI Lib', children: null },
            { id: 46, pid: null, label: 'Reference Data Lib', children: null },
            { id: 60, pid: null, label: 'Business Glossary', children: null },
          ],
        },
        {
          id: 5,
          pid: null,
          label: 'Data Quality',
          children: [
            {
              id: 27,
              pid: null,
              label: 'Data Quality Overview',
              children: [
                { id: 65, pid: null, label: 'DQ Report', children: null },
                { id: 32, pid: null, label: 'Checkpoints Overview', children: null },
              ],
            },
            { id: 29, pid: null, label: 'Rule Template', children: null },
            { id: 28, pid: null, label: 'Rules', children: null },
            { id: 30, pid: null, label: 'DQ Jobs', children: null },
            { id: 31, pid: null, label: 'DQ Issues', children: null },
          ],
        },
        {
          id: 69,
          pid: null,
          label: 'Master Data',
          children: [
            { id: 70, pid: null, label: 'Master Data Catalog', children: null },
            { id: 75, pid: null, label: 'Matser Data Logical Entity Overview', children: null },
          ],
        },
        { id: 2, pid: null, label: 'Data Governance', children: null },
        {
          id: 19,
          pid: null,
          label: 'My Workspace',
          children: [
            { id: 24, pid: null, label: 'Request Management', children: null },
            { id: 20, pid: null, label: 'Data Wheel Management', children: null },
            {
              id: 21,
              pid: null,
              label: 'Data Asset Overview Management',
              children: [{ id: 26, pid: null, label: 'Future Data Asset Management', children: null }],
            },
            {
              id: 23,
              pid: null,
              label: 'Data Standards Management',
              children: [
                { id: 64, pid: null, label: 'Foundational Data Standards Management', children: null },
                { id: 42, pid: null, label: 'KPI Standard Definition', children: null },
                { id: 43, pid: null, label: 'Reference Data Management', children: null },
                { id: 63, pid: null, label: 'Business Glossary Management', children: null },
              ],
            },
            {
              id: 67,
              pid: null,
              label: 'Master Data Management',
              children: [
                { id: 68, pid: null, label: 'Master Data Catalog', children: null },
                { id: 74, pid: null, label: 'Service Management', children: null },
              ],
            },
            {
              id: 34,
              pid: null,
              label: 'Data Quality Management',
              children: [
                { id: 36, pid: null, label: 'DQ Rule Template', children: null },
                { id: 35, pid: null, label: 'DQ Rule', children: null },
                { id: 37, pid: null, label: 'DQ Jobs', children: null },
              ],
            },
            { id: 22, pid: null, label: 'Meta Model Management', children: null },
          ],
        },
        {
          id: 53,
          pid: null,
          label: 'Operations',
          children: [
            { id: 58, pid: null, label: 'Daily Dashboard', children: null },
            { id: 66, pid: null, label: 'Data Asset Permission', children: null },
            { id: 57, pid: null, label: 'Feedback List', children: null },
            { id: 54, pid: null, label: 'User', children: null },
            { id: 55, pid: null, label: 'Role', children: null },
            { id: 56, pid: null, label: 'Privileges', children: null },
          ],
        },
      ],
    },
  },
  '/auth/getUsers': {
    method: 'post',
    data: () => {
      const res = {
        status: '0',
        msg: 'success',
        data: {
          records: [
            {
              id: 10792,
              name: 'Liu Xianan, BBF-453(NEC)',
              displayName: 'Liu Xianan, BBF-453(NEC)',
              firstName: null,
              lastName: null,
              birthName: null,
              gender: null,
              password: null,
              birthday: null,
              idType: null,
              idNumber: null,
              mobile: null,
              telephone: null,
              email: 'Xianan.Liu.fg@partner.bmw-brilliance.cn',
              address: null,
              jobNumber: null,
              didAccount: 'UF204267',
              title: null,
              leader: 0,
              department: 'BBF-453',
              didDepCode: null,
              photo: null,
              dimission: 0,
              createdAt: '2023-02-08 01:00:07',
              updatedAt: '2023-02-08 01:00:07',
              didSyncedAt: '20230207092517Z',
              didEntryId: '0d784597-a510-4de1-acfe-f838a59d5683',
            },
            {
              email: 'yao.ma@lingyue-digital.com',
            },
            {
              email: '123@lingyue-digital.com',
            },
            {
              email: '333@lingyue-digital.com',
            },
            {
              email: '312321@lingyue-digital.com',
            },
            {
              email: '312321412@lingyue-digital.com',
            },
          ],
          total: 1,
          size: 100,
          current: 1,
        },
      };
      return [200, res];
    },
  },
};
